import axiosInstance from '../api.service.js';
import constants from '../../constants/constants';

const ENDPOINTORIGIN = "JobTimeSheet/";

const getTimeSheet = async (id) => await axiosInstance.get(ENDPOINTORIGIN + 'GetJobTimeSheet?id=' + id, constants.REQUIRE_INTERCEPTORS);

const isUserClockedIn = async (jobId, userId) => await axiosInstance.get(ENDPOINTORIGIN + 'IsUserClockedIn?jobId=' + jobId + '&userId=' + userId, constants.REQUIRE_INTERCEPTORS);

const getJobTimeSheets = async (jobId) => await axiosInstance.get(ENDPOINTORIGIN + 'GetJobTimeSheets?jobId=' + jobId, constants.REQUIRE_INTERCEPTORS);

const save = async (model) => await axiosInstance.post(ENDPOINTORIGIN + 'Save?', model, constants.REQUIRE_INTERCEPTORS);

const deleteTimeSheet = async (id) => await axiosInstance.get(ENDPOINTORIGIN + 'Delete?id=' + id, constants.REQUIRE_INTERCEPTORS);

const update = async (model) => await axiosInstance.post(ENDPOINTORIGIN + 'Update?', model, constants.REQUIRE_INTERCEPTORS);

const getJobFinancial = async (model) => await axiosInstance.post(ENDPOINTORIGIN + 'GetJobFinancial?', model, constants.REQUIRE_INTERCEPTORS);

const getCurrentlyClockedInUserIds = async (jobId) => await axiosInstance.get(ENDPOINTORIGIN + 'GetCurrentlyClockedInUserIds?jobId=' + jobId, constants.REQUIRE_INTERCEPTORS);

export {
    getTimeSheet,
    isUserClockedIn,
    getJobTimeSheets,
    getJobFinancial,
    save,
    deleteTimeSheet,
    update,
    getCurrentlyClockedInUserIds
}